import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__copyright">
        © 2021 National Taiwan University Department of Computer Science Multimedia Information Retrieval Lab
      </div>
    </footer>
  );
}

export default Footer;
